const Enums = {
  orderStatus: {
    PROCESSING: 10,
    PAID: 20,
    PAYMENT_FAILED: 21,
    PLACED: 30,
    COOKING: 35,
    FULFILLED: 40,
    CANCELED: 60
  },
  variant: {
    s: 'Small',
    m: 'Medium',
    l: 'Large'
  },
  comboSize: {
    0: 'small',
    1: 'medium',
    2: 'large'
  },
  toastType: {
    default: 'default',
    error: 'error',
    info: 'info',
    success: 'success',
    warning: 'warning',
  },
  orderModeDisplay: {
    WalkIn: 'Take Away',
    EatIn: 'Dine In',
    DriveThru: 'Drive Thru',
    Delivery: 'Delivery'
  },
  orderMode: {
    WalkIn: 'WalkIn',
    EatIn: 'EatIn',
    DriveThru: 'DriveThru',
    Delivery: 'Delivery'
  },
  comboType: {
    quickCombo: 'QuickCombo',
    menuItem: 'MenuItem'
  },
  navigationType: {
    menuItem: 0,
    category: 1,
    displayOnly: 2,
    signUp: 3,
  },
  cardType: {
    visa: 'Visa',
    masterCard: 'Mastercard',
    wallet: 'Apple Pay'
  },
  ModifiersSet: {
    Protien: 2,
    Cheese: 3,
    Sauce: 4,
    PacketSauce: 5,
    Salad: 6,
    Bun: 7,
    ChoiceofSauces: 8,
    SpiceLevel: 9
  },
  ModifiersSetDisplay: {
    2: 'Protien',
    3: 'Cheese',
    4: 'Sauce',
    5: 'PacketSauce',
    6: 'Salad',
    7: 'Bun',
    8: 'Choice of Sauces',
    9: 'Spice Level'
  },
  appForceUpdate: {
    No: 0,
    Ignore: 1,
    Required: 2
  },
  payType: {
    Wallet: 'Wallet',
    Card: 'Card',
    Stars: 'Stars',
  },
  userAlertType: {
    wantsUpdateAndNoNotify: 1,
    notifyAndNoWantsUpdate: 2,
    noNotifyAndNoWantsUpdate: 3
  },
};

export default Enums;
